export default import.meta.ROLLUP_FILE_URL_V47HoeQBgiUEQbXS1PpE9g;